
import {throttle} from "//test.dorelan.eu/cdn/shop/t/10/assets/theme.js?v=87408444286926284141788855836";

// Header padding fix
const header_element = document.querySelector('.header__wrapper');

function stickyHeaderSize() {
  const shouldBeSticky = window.scrollY > 30;
  const isSticky = header_element.classList.contains('dor-header-sticky');
  
  if (isSticky !== shouldBeSticky) {
    header_element.classList.toggle('dor-header-sticky', shouldBeSticky);
  }
}

const checkScrollPosition = throttle(stickyHeaderSize);
document.addEventListener('scroll', checkScrollPosition, {passive: true});